module.exports = __webpack_public_path__ + "img/kommune-1756.b2acdc12.svg";